import styled from 'styled-components';
import React from 'react';

interface LayoutProps {
  children?: React.ReactNode,
}

const SectionContent = ({ children } : LayoutProps) => (
  <SectionContentWrapper>
    {children}
  </SectionContentWrapper>
);

export default SectionContent;

const SectionContentWrapper = styled.div`
  width: 100%;
`;
